import { render, staticRenderFns } from "./AddMeltDownProduct.vue?vue&type=template&id=0d77b2f6"
import script from "./AddMeltDownProduct.vue?vue&type=script&lang=js"
export * from "./AddMeltDownProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports